/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PerplayStatisticsControllerDtoMarketGemStatisticsMarketData model module.
 * @module model/PerplayStatisticsControllerDtoMarketGemStatisticsMarketData
 * @version 1.0
 */
class PerplayStatisticsControllerDtoMarketGemStatisticsMarketData {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoMarketGemStatisticsMarketData</code>.
     * @alias module:model/PerplayStatisticsControllerDtoMarketGemStatisticsMarketData
     */
    constructor() { 
        
        PerplayStatisticsControllerDtoMarketGemStatisticsMarketData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoMarketGemStatisticsMarketData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoMarketGemStatisticsMarketData} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoMarketGemStatisticsMarketData} The populated <code>PerplayStatisticsControllerDtoMarketGemStatisticsMarketData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoMarketGemStatisticsMarketData();

            if (data.hasOwnProperty('targetDate')) {
                obj['targetDate'] = ApiClient.convertToType(data['targetDate'], 'Date');
            }
            if (data.hasOwnProperty('transactionCount')) {
                obj['transactionCount'] = ApiClient.convertToType(data['transactionCount'], 'Number');
            }
            if (data.hasOwnProperty('transactionTotalPrice')) {
                obj['transactionTotalPrice'] = ApiClient.convertToType(data['transactionTotalPrice'], 'Number');
            }
            if (data.hasOwnProperty('transactionTotalFee')) {
                obj['transactionTotalFee'] = ApiClient.convertToType(data['transactionTotalFee'], 'Number');
            }
            if (data.hasOwnProperty('registerCount')) {
                obj['registerCount'] = ApiClient.convertToType(data['registerCount'], 'Number');
            }
            if (data.hasOwnProperty('registerTotalPrice')) {
                obj['registerTotalPrice'] = ApiClient.convertToType(data['registerTotalPrice'], 'Number');
            }
            if (data.hasOwnProperty('registerMinPrice')) {
                obj['registerMinPrice'] = ApiClient.convertToType(data['registerMinPrice'], 'Number');
            }
            if (data.hasOwnProperty('registerMaxPrice')) {
                obj['registerMaxPrice'] = ApiClient.convertToType(data['registerMaxPrice'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoMarketGemStatisticsMarketData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoMarketGemStatisticsMarketData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} targetDate
 */
PerplayStatisticsControllerDtoMarketGemStatisticsMarketData.prototype['targetDate'] = undefined;

/**
 * @member {Number} transactionCount
 */
PerplayStatisticsControllerDtoMarketGemStatisticsMarketData.prototype['transactionCount'] = undefined;

/**
 * @member {Number} transactionTotalPrice
 */
PerplayStatisticsControllerDtoMarketGemStatisticsMarketData.prototype['transactionTotalPrice'] = undefined;

/**
 * @member {Number} transactionTotalFee
 */
PerplayStatisticsControllerDtoMarketGemStatisticsMarketData.prototype['transactionTotalFee'] = undefined;

/**
 * @member {Number} registerCount
 */
PerplayStatisticsControllerDtoMarketGemStatisticsMarketData.prototype['registerCount'] = undefined;

/**
 * @member {Number} registerTotalPrice
 */
PerplayStatisticsControllerDtoMarketGemStatisticsMarketData.prototype['registerTotalPrice'] = undefined;

/**
 * @member {Number} registerMinPrice
 */
PerplayStatisticsControllerDtoMarketGemStatisticsMarketData.prototype['registerMinPrice'] = undefined;

/**
 * @member {Number} registerMaxPrice
 */
PerplayStatisticsControllerDtoMarketGemStatisticsMarketData.prototype['registerMaxPrice'] = undefined;






export default PerplayStatisticsControllerDtoMarketGemStatisticsMarketData;

